<mat-card>
    <mat-card-header>
        <mat-card-title class="mat-card-title-custom">
            <span>{{'headertable.decline_multi_result' | translate}}</span>
        </mat-card-title>
    </mat-card-header>


    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <mat-expansion-panel expanded="true" class="mb-3 mt-3">
            <mat-expansion-panel-header>
                <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);">
                    {{ "title.decline_batch_info" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row" #focus tabindex="-1">
                <div class="col-6 col-sm-6 col-lg-2 col-form-label">{{'search_form.time_start_process' |
                    translate}}
                </div>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{startTime}},
                    {{startDate}}</div>

                <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_approve_batch' |
                    translate}}
                </div>
                <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{data ? data.noOfSelected : 0}}</div>
            </div>

            <div class="row">
                <div class="col-6 col-sm-6 col-lg-2 col-form-label">{{'search_form.time_stop_process' |
                    translate}}</div>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{endTime}},
                    {{endDate}}</div>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_decline_batch_success' |
                    translate}}
                </div>
                <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{data ? data.noOfSuccess : 0}}</div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-6 col-lg-2 col-form-label">{{'search_form.reason' |
                    translate}}</div>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label font-w       eight-bold">{{data ? data.group.comment : 0}}</div>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_decline_batch_cancel' |
                    translate}}
                </div>
                <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{data ? data.noOfFailed : 0}}</div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-6 col-lg-6 col-form-label"></div>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_approve_batch_processing' |
                    translate}}
                </div>
                <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{data ? data.noOfProcessing : 0}}</div>
            </div>

        </mat-expansion-panel>

        <mat-expansion-panel expanded="true" class="mb-3 mt-3">
            <mat-expansion-panel-header>
                <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);">
                    {{ "title.multi_decline_list" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-table [dataSource]="dataSource" class="mt-3">
                <!-- STT -->
                <ng-container matColumnDef="STT">
                    <mat-header-cell *matHeaderCellDef
                        class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                        {{'enterprise_contract.table_headers.No' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element, let i = index"
                        class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                        {{i + 1}}
                    </mat-cell>
                </ng-container>

                <!-- Tên tài liệu Column -->
                <ng-container matColumnDef="contractName">
                    <mat-header-cell *matHeaderCellDef style="max-width: 30%" class="mat-cell-non-boder-right-bottom">
                        {{'headertable.document_code_name' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="max-width: 30%"
                        matTooltip="{{element.contractNameCode ? element.contractNameCode : element.name}}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                        <span class="fix-width">{{element.nameOrCode}}</span>
                    </mat-cell>
                </ng-container>

                <!-- party Column -->
                <ng-container matColumnDef="party">
                    <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                        {{'headertable.sign_party' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="max-width: 20%;" (click)="$event.stopPropagation()"
                        matTooltip="{{element.allName}}"    
                        class="mat-cell-non-boder-right-bottom">
                        <span class="fix-width">{{element.allName}}</span>
                    </mat-cell>
                </ng-container>

                <!-- result Column -->
                <ng-container matColumnDef="result">
                    <mat-header-cell *matHeaderCellDef style="max-width: 10%;" class="mat-cell-non-boder-right-bottom">
                        {{'headertable.sign_batch_status' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="max-width: 10%;" (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom" matTooltip="{{renderStatus(element.status)}}">
                        <span class="fix-width text-center"
                            [ngStyle]="renderStatusColor(element.status)">{{renderStatus(element.status)}}</span>
                    </mat-cell>
                </ng-container>

                <!-- Chi tiết Column -->
                <ng-container matColumnDef="detail">
                    <mat-header-cell *matHeaderCellDef>
                        {{'headertable.detail_sign' | translate}}
                    </mat-header-cell>
                    <mat-cell  *matCellDef="let element" (click)="$event.stopPropagation()"
                        matTooltip="{{element.status === -1 ? element.description : ''}}">
                        <span *ngIf="element.status === -1" class="fix-width">{{element.description ? element.description : ''}}</span>
                    </mat-cell>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef style="max-width: 5%;" class="text-center">
                        {{'headertable.sign_action' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="max-width: 5%;" (click)="$event.stopPropagation()"
                        class="text-center">
                        <button mat-icon-button type="button" (click)="openViewDialog(element.id)">
                            <mat-icon matTooltip="{{'title.detail' | translate}}">visibility</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
                    [cdkDetailRow]="row">
                </mat-row>
            </mat-table>

            <div class="row pb-3 py-3" *ngIf="isActiveRetry && hasMultiSign && !errorRetry">
                <div class="col-12">
                    <div style="width: 90%">
                        <span style="color: #fc1203">{{ "search_form.has_multi_sign" | translate }}</span>
                    </div>
                </div>
            </div>
            
            <div class="row pb-3 py-3" *ngIf="isActiveRetry && errorRetry && !hasMultiSign">
                <div class="col-12">
                    <div style="width: 90%">
                        <span style="color: #fc1203">{{ "search_form.error_decline_batch" | translate }}</span>
                        <a style="cursor: pointer; word-break: break-word; color: #008CF6;" 
                            (click)="navigateSignedContract()">{{"title.document_search_approve_all" | translate}}</a>
                        <span style="color: #fc1203">{{ "search_form.sign_batch_recheck" | translate }}</span>
                    </div>
                </div>
            </div>
            
            <div class="scontract-btn-dsk bg-white text-center mat-elevation-z0 py-3 w-100" *ngIf="isActiveRetry && !errorRetry">
                <button mat-raised-button color="primary" class="btn mr-3" (click)="openSignPage()">
                    <mat-icon class="mr-0">not_interested</mat-icon>
                    {{ "enterprise_contract.buttons.decline_approve_batch" | translate }}
                </button>
            </div>

        </mat-expansion-panel>

    </mat-card-content>
</mat-card>